export default "__VITE_ASSET__c01e9c64__"